export const POINTER = {
  GRAB: "grab",
  GRABBING: "grabbing",
  HOVER: "hover",
  ZOOM_IN: "zoom-in",
  ZOOM_OUT: "zoom-out",
};

export const POINTER_EVENT = "board-pointer";
